module.exports = __webpack_public_path__ + "static/media/acms_me.9dbd32f8.svg";